<template>
  <div class="system-info-page">
    <Form :label-width="100">
      <div class="fielset">
        <h3>{{$t("system.SystemInfo.Information")}}</h3>
        <FormItem :label="$t('system.SystemInfo.systemName')">
            <Input class="info" v-model="systemName" :placeholder="$t('system.SystemInfo.please_enter')"></Input>
        </FormItem>
        <FormItem :label="$t('system.SystemInfo.name')">
            <Input class="info" v-model="name" :placeholder="$t('system.SystemInfo.please_enter')"></Input>
        </FormItem>
      </div>
      <div class="fielset">
        <h3>{{$t("system.SystemInfo.Contect")}}</h3>
        <FormItem :label="$t('system.SystemInfo.contact')">
            <Input class="info" v-model="contact" :placeholder="$t('system.SystemInfo.please_enter')"></Input>
        </FormItem>
        <FormItem :label="$t('system.SystemInfo.address')">
            <Input class="info" v-model="address" :placeholder="$t('system.SystemInfo.please_enter')"></Input>
        </FormItem>
        <FormItem :label="$t('system.SystemInfo.phone')">
            <Input class="info" v-model="phone" :placeholder="$t('system.SystemInfo.please_enter')"></Input>
        </FormItem>
        <FormItem :label="$t('system.SystemInfo.fax')">
            <Input class="info" v-model="fax" :placeholder="$t('system.SystemInfo.please_enter')"></Input>
        </FormItem>
        <FormItem :label="$t('system.SystemInfo.eMail')">
            <Input class="info" v-model="eMail" :placeholder="$t('system.SystemInfo.please_enter')"></Input>
        </FormItem>
      </div>
      <hr>
      <div class="save-btn">
        <Button type="primary" v-if="permissions === true" @click="save()">{{$t("system.SystemInfo.save")}}</Button>
        <Button type="primary" v-if="permissions !== true" @click="save()" disabled>{{$t("system.SystemInfo.save")}}</Button>
      </div>
    </Form>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'SystemInfo',
  data () {
    return {
      systemName: '',
      name: '',
      contact: '',
      address: '',
      phone: '',
      eMail: '',
      fax: '',
      warnLimitTime: '',
      permissions: false
    }
  },
  mounted () {
    Api.system.get().then(res => {
      let info = res.company
      this.systemName = info.systemName
      this.name = info.name
      this.contact = info.contact
      this.address = info.address
      this.phone = info.phone
      this.eMail = info.eMail
      this.fax = info.fax
      this.language = info.language
      this.warnLimitTime = info.warnLimitTime
    })
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  methods: {
    save () {
      let info = {
        systemName: this.systemName,
        name: this.name,
        contact: this.contact,
        address: this.address,
        phone: this.phone,
        eMail: this.eMail,
        fax: this.fax,
        warnLimitTime: this.warnLimitTime
      }
      Api.system.save(info).then(() => {
        this.$Message.config({
          top: 80,
          duration: 2
        })
        this.$Message.success(this.$t('system.SystemInfo.save_success'))
      })
    }
  }
}
</script>
<style scoped>
  .system-info-page {
    padding: 10px;
    padding-left: 20px;
  }
  .fielset .info {
    width: 33.3333%;
  }
  .save-btn {
    text-align: left;
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
</style>


// WEBPACK FOOTER //
// SystemInfo.vue?70c5c141